export * from './updateComponent';
